// extracted by mini-css-extract-plugin
export default {"dialog":"LogoutRequiredDialog_dialog__e4rPw","icon":"LogoutRequiredDialog_icon__tKEqu","buttons":"LogoutRequiredDialog_buttons__zfHQD"};